/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { addItem } from "../Redux/Addtochart";
import { addItemInList } from "../Redux/wishlistSlice";
import toast, { Toaster } from "react-hot-toast";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import StarRatings from "react-star-ratings";

const Section1 = () => {
  const [selectedValue, setSelectedValue] = useState("");
  const [filterplant, setfilterplant] = useState("");
  const [filterweight, setfilterweight] = useState("");
  const [peicefilter, setpricefilter] = useState("");
  const [search, setSearch] = useState("");
  const [getcatagory, setcatagory] = useState([]);
  const disptach = useDispatch();
  const navigate = useNavigate();
  const [data, setdata] = useState([]);
  useEffect(() => {
    axios
      .get(`https://api.weedowl.dev-iuh.xyz/api/categories`)
      .then((res) => {
        setcatagory(res?.data?.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  useEffect(() => {
    if (selectedValue || filterplant || filterweight || peicefilter) {
      fetachdatafillter();
    } else {
      fetachdata();
    }
  }, [selectedValue, filterplant, filterweight, peicefilter]);

  const fetachdata = async () => {
    await axios
      .get("https://api.weedowl.dev-iuh.xyz/api/products")
      .then((res) => {
        setdata(res?.data?.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const fetachdatafillter = async () => {
    await axios
      .get(
        `https://api.weedowl.dev-iuh.xyz/api/products?category=${selectedValue}&plant_type=${filterplant}&weight=${filterweight}&amount=${peicefilter}`
      )
      .then((res) => {
        setdata(res?.data?.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const handleRadioChange = (event) => {
    setSelectedValue(event.target.value);
  };
  const handlplantchange = (event) => {
    setfilterplant(event.target.value);
  };
  const handleweightchange = (event) => {
    setfilterweight(event.target.value);
  };
  const Addtochart = (data) => {
    console.log(data, "checkout");
    const Datatosend = {
      image: data.media,
      name: data.title,
      price: data.discounted_amount,
      qty: 1,
      id: data.id,
      rating :data.rating,
      thc:data.thc,
      cbd:data.cbd,
      weight:data.weight
    };
    disptach(addItem(Datatosend));
    toast.success("Added Successfully!");
  };
  const Addtolist = (data) => {
    const Datatosend = {
      image: data.media,
      name: data.title,
      price: data.amount,
      id: data.id,
      rating :data.rating,
      thc:data.thc,
      cbd:data.cbd,
      weight:data.weight
    };
    disptach(addItemInList(Datatosend));
    toast.success("Added To List Successfully!");
  };
  const resetfilter = () => {
    setSelectedValue("");
    setfilterplant("");
    setfilterweight("");
    setpricefilter("");
  };
  console.log(search,'sdashghghjhbnb')
  const Gotosignalpage = (id) => {
    navigate(`/singleproduct/${id}`);
  };
  return (
    <div className="shop-wrapper mt-2 px-5">
      <Toaster position="top-right" reverseOrder={false} />
      <div className="container d-flex flex-lg-row flex-wrap flex-column justify-content-between">
        <a
          className="filterTrigger d-flex d-lg-none align-items-center justify-content-center"
          href="/"
          data-bs-toggle="collapse"
          data-bs-target="#shopFilters"
        >
          Filters <i className="icon-caret_down icon" />
        </a>
        <div className="shop_products d-flex flex-column">
          <ul className="shop_products-list d-sm-flex flex-wrap">
            {(search
              ? data?.filter((datafilter) => datafilter.title.toLowerCase().includes(search.toLowerCase()))
              : data
            ).map((data, index) => {
              return (
                <li
                  className="shop_products-list_item col-sm-6 col-md-4 col-lg-6 col-xl-4"
                  data-order={index}
                >
                  <div className="wrapper d-flex flex-column">
                    <div className="media">
                      <div className="overlay d-flex flex-column align-items-center justify-content-center">
                        <ul className="action d-flex align-items-center justify-content-center">
                          <li className="list-item"></li>
                          <li className="list-item">
                            <div className="action_link d-flex align-items-center justify-content-center">
                              <i
                                className="icon-basket"
                                onClick={() => Addtochart(data)}
                              />
                            </div>
                          </li>
                          <li className="list-item">
                            <div
                              className="action_link d-flex align-items-center justify-content-center"
                              data-role="wishlist"
                            >
                              <i
                                className="icon-heart"
                                onClick={() => Addtolist(data)}
                              />
                            </div>
                          </li>
                          <li className="list-item">
                            <div
                              className="action_link d-flex align-items-center justify-content-center"
                              data-trigger="view"
                            >
                              <i
                                className="icon-eye"
                                onClick={() => Gotosignalpage(data.id)}
                              />
                            </div>
                          </li>
                        </ul>
                      </div>

                      <img
                        className="lazy"
                        src={data.media[0].media}
                        alt="media"
                      />
                    </div>
                    <div className="main d-flex flex-column">
                      <div className="main_rating">
                      <StarRatings
                          rating={data.rating}
                          starRatedColor="#efc368"
                          // changeRating={changeRating}
                          numberOfStars={5}
                          starDimension="30px"
                          name="rating"
                        />
                       
                      </div>

                      <h4 className="my-2">{data.title}</h4>
                      <div className="main_price">
                        {data.is_discounted ? (
                          <>
                            <span className="price price--old">
                              {data.amount}
                            </span>
                            <span className="price">
                              ${data.discounted_amount}
                            </span>
                          </>
                        ) : (
                          <span className="price">${data.amount}</span>
                        )}
                      </div>
                    </div>
                  </div>
                </li>
              );
            })}
          </ul>
          {/* <ul className="pagination d-flex align-items-center">
          <li className="pagination-page">
            <a
              className="pagination-page_link d-flex align-items-center justify-content-center"
              href="/"
              data-current="true"
            >
              1
            </a>
          </li>
          <li className="pagination-page">
            <a
              className="pagination-page_link d-flex align-items-center justify-content-center"
              href="/"
            >
              2
            </a>
          </li>
          <li className="pagination-page">
            <a
              className="pagination-page_link d-flex align-items-center justify-content-center"
              href="/"
            >
              3
            </a>
          </li>
        </ul> */}
        </div>
        <div className="shop_aside">
          <div className="shop_aside-wrapper collapse" id="shopFilters">
            <div className="shop_aside-block shop_aside-block--search mb-2">
              <h4 className="shop_aside-block_header d-flex align-items-center">
                <span className="leaf">
                  <svg
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M19.584 22.1185C18.1022 22.2634 16.697 21.9115 15.3804 20.9798C15.3517 20.9591 15.3229 20.9409 15.2942 20.9202C16.089 22.1625 16.1225 23.3349 16.539 24C15.4043 23.4643 14.4707 22.7914 13.8507 21.9089C13.7574 22.0486 13.7215 22.2272 13.8172 22.4808C13.032 21.7872 12.4312 20.6899 11.9524 19.3208C11.9476 19.3312 11.9452 19.3415 11.9405 19.3493C11.4641 20.7054 10.8656 21.7924 10.0828 22.4808C10.181 22.2272 10.1451 22.0486 10.0493 21.9089C9.42932 22.7914 8.49572 23.4643 7.36104 24C7.77757 23.3375 7.81109 22.1625 8.60584 20.9202C8.56514 20.9487 8.52445 20.9798 8.48615 21.0031C7.17911 21.9141 5.78829 22.2609 4.31848 22.1185C4.56983 22.0228 4.73979 21.8649 4.79964 21.632C2.34117 21.7614 1.12031 20.8711 0 19.898C0.0406952 19.9006 0.0837842 19.9057 0.126873 19.9083C1.57993 19.9808 3.97616 18.5651 6.62853 17.9052C6.61656 17.9 6.6022 17.8948 6.59262 17.8896C3.61709 16.6784 1.9031 14.7451 1.01977 12.3408C1.17537 12.5246 1.35012 12.6178 1.54402 12.6204C0.608034 9.7735 0.677455 7.77035 1.37885 6.29774C1.49375 8.05762 6.66204 9.6855 8.90028 13.3968C8.89071 13.3528 8.88113 13.314 8.87395 13.27C8.32576 10.8087 8.47418 8.07315 9.16121 5.13053C9.20908 5.79307 9.31202 6.22269 9.69982 6.49185C9.91048 3.89085 10.643 1.79971 11.95 0.267578C13.2571 1.79971 13.9896 3.89085 14.2002 6.49185C14.588 6.22269 14.691 5.79307 14.7388 5.13053C15.4378 8.12491 15.5791 10.9045 14.9974 13.3968C15.0309 13.3372 15.0668 13.2829 15.1027 13.2234C15.1051 13.2208 15.1051 13.2182 15.1075 13.213C17.2691 9.84079 21.8318 8.22067 22.4494 6.59796V6.59537C22.4901 6.49702 22.5116 6.39609 22.5188 6.29515C23.2202 7.76776 23.2896 9.77091 22.3536 12.6178C22.5475 12.6126 22.7247 12.5194 22.8779 12.3383C21.9898 14.7529 20.2662 16.6914 17.2691 17.9026C17.3074 17.9129 17.3457 17.9233 17.3816 17.931C20.0651 18.6246 22.4781 20.0584 23.8977 19.8954C22.7797 20.8685 21.5589 21.7588 19.098 21.6294C19.1627 21.8675 19.3302 22.0228 19.584 22.1185Z"
                      fill="#258F67"
                    />
                    <path
                      d="M12.3627 16.6732C12.3627 16.6732 9.45119 17.3788 6.85934 17.5985C3.80271 16.3889 2.04202 14.4581 1.13462 12.057C1.29446 12.2405 1.47398 12.3335 1.67316 12.3361C0.711665 9.49296 0.782978 7.49241 1.50348 6.02173C1.50594 6.02173 1.79857 15.6032 12.3627 16.6732Z"
                      fill="#214842"
                    />
                    <path
                      d="M11.7116 16.7864C11.7116 16.7864 10.0667 16.3102 8.77415 13.0731C8.25027 10.5985 8.39211 7.84804 9.04868 4.88941C9.09443 5.55556 9.1928 5.98751 9.56341 6.25813C9.76473 3.64299 10.4648 1.54046 11.7138 0C11.2174 6.38824 10.904 12.4824 11.7116 16.7864Z"
                      fill="#214842"
                    />
                    <path
                      d="M22.3487 6.552C20.8856 12.8009 17.0985 15.79 12.0293 16.9711C13.0596 16.6693 14.1769 15.0226 15.1296 13.2119C15.132 13.2093 15.132 13.2067 15.1343 13.2015C17.2608 9.81172 21.7419 8.18576 22.3487 6.552Z"
                      fill="#214842"
                    />
                    <path
                      d="M23.9996 19.4003C19.2292 19.9109 15.026 19.3955 12.0508 16.6816C12.0508 16.6816 14.9231 17.4656 17.4842 17.5807C20.1675 18.2208 22.5778 19.5513 23.9996 19.4003Z"
                      fill="#214842"
                    />
                    <path
                      d="M16.4192 23.6094C14.6332 21.5095 13.2143 19.1771 12.0742 16.6633C13.1894 18.0582 14.3113 19.4709 15.3222 20.6281C15.295 20.6077 15.2678 20.5898 15.2406 20.5694C15.9931 21.7982 16.0249 22.9554 16.4192 23.6094Z"
                      fill="#214842"
                    />
                    <path
                      d="M12.2037 19.1457C11.7042 20.4843 11.0767 21.5573 10.256 22.2368C10.3589 21.9864 10.3213 21.8102 10.2209 21.6722C9.57084 22.5433 8.59201 23.2076 7.40234 23.7364C9.34998 21.5445 10.9713 19.2351 12.2137 16.7903C12.3342 17.2476 12.299 18.1545 12.2037 19.1457Z"
                      fill="#214842"
                    />
                    <path
                      d="M12.0016 16.896C11.9154 17.0026 10.0093 19.3149 8.54143 20.9535C7.23401 21.8691 5.84277 22.2176 4.37251 22.0746C4.62394 21.9783 4.79395 21.8197 4.85382 21.5856C2.39461 21.7156 1.17339 20.8209 0.0527344 19.8429C0.0934418 19.8455 0.136544 19.8507 0.179646 19.8533C4.51858 20.2227 8.54862 19.5204 12.0016 16.896Z"
                      fill="#214842"
                    />
                    <path
                      d="M12.811 16.7992C12.811 17.2789 12.4464 17.6674 11.9963 17.6674C11.5462 17.6674 11.1816 17.2789 11.1816 16.7992C11.1816 16.3195 11.5462 15.9309 11.9963 15.9309C12.4464 15.9309 12.811 16.3195 12.811 16.7992Z"
                      fill="#214842"
                    />
                  </svg>{" "}
                </span>
                Search by Products
              </h4>
              <form
                className="form form--search"
                data-type="searchProducts"
                action="#"
                method="get"
              >
                <input
                  className="field required"
                  type="text"
                  placeholder="Search..."
                  onChange={(e) => setSearch(e.target.value)}
                />
               
              </form>
              <button className="btn mt-3" onClick={resetfilter} type="submit">
                Reset Fillter
              </button>
            </div>
            <div className="shop_aside-block shop_aside-block--categories">
              <h4 className="shop_aside-block_header d-flex align-items-center mt-3">
                <span className="leaf">
                  <svg
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M19.584 22.1185C18.1022 22.2634 16.697 21.9115 15.3804 20.9798C15.3517 20.9591 15.3229 20.9409 15.2942 20.9202C16.089 22.1625 16.1225 23.3349 16.539 24C15.4043 23.4643 14.4707 22.7914 13.8507 21.9089C13.7574 22.0486 13.7215 22.2272 13.8172 22.4808C13.032 21.7872 12.4312 20.6899 11.9524 19.3208C11.9476 19.3312 11.9452 19.3415 11.9405 19.3493C11.4641 20.7054 10.8656 21.7924 10.0828 22.4808C10.181 22.2272 10.1451 22.0486 10.0493 21.9089C9.42932 22.7914 8.49572 23.4643 7.36104 24C7.77757 23.3375 7.81109 22.1625 8.60584 20.9202C8.56514 20.9487 8.52445 20.9798 8.48615 21.0031C7.17911 21.9141 5.78829 22.2609 4.31848 22.1185C4.56983 22.0228 4.73979 21.8649 4.79964 21.632C2.34117 21.7614 1.12031 20.8711 0 19.898C0.0406952 19.9006 0.0837842 19.9057 0.126873 19.9083C1.57993 19.9808 3.97616 18.5651 6.62853 17.9052C6.61656 17.9 6.6022 17.8948 6.59262 17.8896C3.61709 16.6784 1.9031 14.7451 1.01977 12.3408C1.17537 12.5246 1.35012 12.6178 1.54402 12.6204C0.608034 9.7735 0.677455 7.77035 1.37885 6.29774C1.49375 8.05762 6.66204 9.6855 8.90028 13.3968C8.89071 13.3528 8.88113 13.314 8.87395 13.27C8.32576 10.8087 8.47418 8.07315 9.16121 5.13053C9.20908 5.79307 9.31202 6.22269 9.69982 6.49185C9.91048 3.89085 10.643 1.79971 11.95 0.267578C13.2571 1.79971 13.9896 3.89085 14.2002 6.49185C14.588 6.22269 14.691 5.79307 14.7388 5.13053C15.4378 8.12491 15.5791 10.9045 14.9974 13.3968C15.0309 13.3372 15.0668 13.2829 15.1027 13.2234C15.1051 13.2208 15.1051 13.2182 15.1075 13.213C17.2691 9.84079 21.8318 8.22067 22.4494 6.59796V6.59537C22.4901 6.49702 22.5116 6.39609 22.5188 6.29515C23.2202 7.76776 23.2896 9.77091 22.3536 12.6178C22.5475 12.6126 22.7247 12.5194 22.8779 12.3383C21.9898 14.7529 20.2662 16.6914 17.2691 17.9026C17.3074 17.9129 17.3457 17.9233 17.3816 17.931C20.0651 18.6246 22.4781 20.0584 23.8977 19.8954C22.7797 20.8685 21.5589 21.7588 19.098 21.6294C19.1627 21.8675 19.3302 22.0228 19.584 22.1185Z"
                      fill="#258F67"
                    />
                    <path
                      d="M12.3627 16.6732C12.3627 16.6732 9.45119 17.3788 6.85934 17.5985C3.80271 16.3889 2.04202 14.4581 1.13462 12.057C1.29446 12.2405 1.47398 12.3335 1.67316 12.3361C0.711665 9.49296 0.782978 7.49241 1.50348 6.02173C1.50594 6.02173 1.79857 15.6032 12.3627 16.6732Z"
                      fill="#214842"
                    />
                    <path
                      d="M11.7116 16.7864C11.7116 16.7864 10.0667 16.3102 8.77415 13.0731C8.25027 10.5985 8.39211 7.84804 9.04868 4.88941C9.09443 5.55556 9.1928 5.98751 9.56341 6.25813C9.76473 3.64299 10.4648 1.54046 11.7138 0C11.2174 6.38824 10.904 12.4824 11.7116 16.7864Z"
                      fill="#214842"
                    />
                    <path
                      d="M22.3487 6.552C20.8856 12.8009 17.0985 15.79 12.0293 16.9711C13.0596 16.6693 14.1769 15.0226 15.1296 13.2119C15.132 13.2093 15.132 13.2067 15.1343 13.2015C17.2608 9.81172 21.7419 8.18576 22.3487 6.552Z"
                      fill="#214842"
                    />
                    <path
                      d="M23.9996 19.4003C19.2292 19.9109 15.026 19.3955 12.0508 16.6816C12.0508 16.6816 14.9231 17.4656 17.4842 17.5807C20.1675 18.2208 22.5778 19.5513 23.9996 19.4003Z"
                      fill="#214842"
                    />
                    <path
                      d="M16.4192 23.6094C14.6332 21.5095 13.2143 19.1771 12.0742 16.6633C13.1894 18.0582 14.3113 19.4709 15.3222 20.6281C15.295 20.6077 15.2678 20.5898 15.2406 20.5694C15.9931 21.7982 16.0249 22.9554 16.4192 23.6094Z"
                      fill="#214842"
                    />
                    <path
                      d="M12.2037 19.1457C11.7042 20.4843 11.0767 21.5573 10.256 22.2368C10.3589 21.9864 10.3213 21.8102 10.2209 21.6722C9.57084 22.5433 8.59201 23.2076 7.40234 23.7364C9.34998 21.5445 10.9713 19.2351 12.2137 16.7903C12.3342 17.2476 12.299 18.1545 12.2037 19.1457Z"
                      fill="#214842"
                    />
                    <path
                      d="M12.0016 16.896C11.9154 17.0026 10.0093 19.3149 8.54143 20.9535C7.23401 21.8691 5.84277 22.2176 4.37251 22.0746C4.62394 21.9783 4.79395 21.8197 4.85382 21.5856C2.39461 21.7156 1.17339 20.8209 0.0527344 19.8429C0.0934418 19.8455 0.136544 19.8507 0.179646 19.8533C4.51858 20.2227 8.54862 19.5204 12.0016 16.896Z"
                      fill="#214842"
                    />
                    <path
                      d="M12.811 16.7992C12.811 17.2789 12.4464 17.6674 11.9963 17.6674C11.5462 17.6674 11.1816 17.2789 11.1816 16.7992C11.1816 16.3195 11.5462 15.9309 11.9963 15.9309C12.4464 15.9309 12.811 16.3195 12.811 16.7992Z"
                      fill="#214842"
                    />
                  </svg>{" "}
                </span>
                Product Categories
              </h4>
              <ul className="list">
                {getcatagory?.map((data, index) => {
                  return (
                    <li className="list-item d-flex align-items-center">
                      <input
                        value={data.name}
                        onChange={handleRadioChange}
                        type="radio"
                        checked={selectedValue === data.name}
                        id={data.id}
                        name="category"
                      />
                      <label htmlFor={data.id}>{data.name}</label>
                    </li>
                  );
                })}
              </ul>
            </div>
            <div className="shop_aside-block shop_aside-block--types">
              <h4 className="shop_aside-block_header d-flex align-items-center">
                <span className="leaf">
                  <svg
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M19.584 22.1185C18.1022 22.2634 16.697 21.9115 15.3804 20.9798C15.3517 20.9591 15.3229 20.9409 15.2942 20.9202C16.089 22.1625 16.1225 23.3349 16.539 24C15.4043 23.4643 14.4707 22.7914 13.8507 21.9089C13.7574 22.0486 13.7215 22.2272 13.8172 22.4808C13.032 21.7872 12.4312 20.6899 11.9524 19.3208C11.9476 19.3312 11.9452 19.3415 11.9405 19.3493C11.4641 20.7054 10.8656 21.7924 10.0828 22.4808C10.181 22.2272 10.1451 22.0486 10.0493 21.9089C9.42932 22.7914 8.49572 23.4643 7.36104 24C7.77757 23.3375 7.81109 22.1625 8.60584 20.9202C8.56514 20.9487 8.52445 20.9798 8.48615 21.0031C7.17911 21.9141 5.78829 22.2609 4.31848 22.1185C4.56983 22.0228 4.73979 21.8649 4.79964 21.632C2.34117 21.7614 1.12031 20.8711 0 19.898C0.0406952 19.9006 0.0837842 19.9057 0.126873 19.9083C1.57993 19.9808 3.97616 18.5651 6.62853 17.9052C6.61656 17.9 6.6022 17.8948 6.59262 17.8896C3.61709 16.6784 1.9031 14.7451 1.01977 12.3408C1.17537 12.5246 1.35012 12.6178 1.54402 12.6204C0.608034 9.7735 0.677455 7.77035 1.37885 6.29774C1.49375 8.05762 6.66204 9.6855 8.90028 13.3968C8.89071 13.3528 8.88113 13.314 8.87395 13.27C8.32576 10.8087 8.47418 8.07315 9.16121 5.13053C9.20908 5.79307 9.31202 6.22269 9.69982 6.49185C9.91048 3.89085 10.643 1.79971 11.95 0.267578C13.2571 1.79971 13.9896 3.89085 14.2002 6.49185C14.588 6.22269 14.691 5.79307 14.7388 5.13053C15.4378 8.12491 15.5791 10.9045 14.9974 13.3968C15.0309 13.3372 15.0668 13.2829 15.1027 13.2234C15.1051 13.2208 15.1051 13.2182 15.1075 13.213C17.2691 9.84079 21.8318 8.22067 22.4494 6.59796V6.59537C22.4901 6.49702 22.5116 6.39609 22.5188 6.29515C23.2202 7.76776 23.2896 9.77091 22.3536 12.6178C22.5475 12.6126 22.7247 12.5194 22.8779 12.3383C21.9898 14.7529 20.2662 16.6914 17.2691 17.9026C17.3074 17.9129 17.3457 17.9233 17.3816 17.931C20.0651 18.6246 22.4781 20.0584 23.8977 19.8954C22.7797 20.8685 21.5589 21.7588 19.098 21.6294C19.1627 21.8675 19.3302 22.0228 19.584 22.1185Z"
                      fill="#258F67"
                    />
                    <path
                      d="M12.3627 16.6732C12.3627 16.6732 9.45119 17.3788 6.85934 17.5985C3.80271 16.3889 2.04202 14.4581 1.13462 12.057C1.29446 12.2405 1.47398 12.3335 1.67316 12.3361C0.711665 9.49296 0.782978 7.49241 1.50348 6.02173C1.50594 6.02173 1.79857 15.6032 12.3627 16.6732Z"
                      fill="#214842"
                    />
                    <path
                      d="M11.7116 16.7864C11.7116 16.7864 10.0667 16.3102 8.77415 13.0731C8.25027 10.5985 8.39211 7.84804 9.04868 4.88941C9.09443 5.55556 9.1928 5.98751 9.56341 6.25813C9.76473 3.64299 10.4648 1.54046 11.7138 0C11.2174 6.38824 10.904 12.4824 11.7116 16.7864Z"
                      fill="#214842"
                    />
                    <path
                      d="M22.3487 6.552C20.8856 12.8009 17.0985 15.79 12.0293 16.9711C13.0596 16.6693 14.1769 15.0226 15.1296 13.2119C15.132 13.2093 15.132 13.2067 15.1343 13.2015C17.2608 9.81172 21.7419 8.18576 22.3487 6.552Z"
                      fill="#214842"
                    />
                    <path
                      d="M23.9996 19.4003C19.2292 19.9109 15.026 19.3955 12.0508 16.6816C12.0508 16.6816 14.9231 17.4656 17.4842 17.5807C20.1675 18.2208 22.5778 19.5513 23.9996 19.4003Z"
                      fill="#214842"
                    />
                    <path
                      d="M16.4192 23.6094C14.6332 21.5095 13.2143 19.1771 12.0742 16.6633C13.1894 18.0582 14.3113 19.4709 15.3222 20.6281C15.295 20.6077 15.2678 20.5898 15.2406 20.5694C15.9931 21.7982 16.0249 22.9554 16.4192 23.6094Z"
                      fill="#214842"
                    />
                    <path
                      d="M12.2037 19.1457C11.7042 20.4843 11.0767 21.5573 10.256 22.2368C10.3589 21.9864 10.3213 21.8102 10.2209 21.6722C9.57084 22.5433 8.59201 23.2076 7.40234 23.7364C9.34998 21.5445 10.9713 19.2351 12.2137 16.7903C12.3342 17.2476 12.299 18.1545 12.2037 19.1457Z"
                      fill="#214842"
                    />
                    <path
                      d="M12.0016 16.896C11.9154 17.0026 10.0093 19.3149 8.54143 20.9535C7.23401 21.8691 5.84277 22.2176 4.37251 22.0746C4.62394 21.9783 4.79395 21.8197 4.85382 21.5856C2.39461 21.7156 1.17339 20.8209 0.0527344 19.8429C0.0934418 19.8455 0.136544 19.8507 0.179646 19.8533C4.51858 20.2227 8.54862 19.5204 12.0016 16.896Z"
                      fill="#214842"
                    />
                    <path
                      d="M12.811 16.7992C12.811 17.2789 12.4464 17.6674 11.9963 17.6674C11.5462 17.6674 11.1816 17.2789 11.1816 16.7992C11.1816 16.3195 11.5462 15.9309 11.9963 15.9309C12.4464 15.9309 12.811 16.3195 12.811 16.7992Z"
                      fill="#214842"
                    />
                  </svg>
                </span>
                Plant Type
              </h4>
              <ul className="list">
                <li className="list-item">
                  <input
                    onChange={handlplantchange}
                    checked={filterplant === "Indica-Dominant"}
                    type="radio"
                    value={"Indica-Dominant"}
                    id="indica"
                    name="type"
                  />
                  <label htmlFor="indica">Indica-Dominant</label>
                </li>
                <li className="list-item">
                  <input
                    onChange={handlplantchange}
                    checked={filterplant === "Sativa-Dominant"}
                    value={"Sativa-Dominant"}
                    type="radio"
                    id="sativa"
                    name="type"
                  />
                  <label htmlFor="sativa">Sativa-Dominant</label>
                </li>
                <li className="list-item">
                  <input
                    type="radio"
                    id="hybrid"
                    name="type"
                    onChange={handlplantchange}
                    value={"Hybrid"}
                    checked={filterplant === "Hybrid"}
                  />
                  <label htmlFor="hybrid">Hybrid</label>
                </li>
              </ul>
            </div>
            <div className="shop_aside-block shop_aside-block--weight">
              <h4 className="shop_aside-block_header d-flex align-items-center">
                <span className="leaf">
                  <svg
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M19.584 22.1185C18.1022 22.2634 16.697 21.9115 15.3804 20.9798C15.3517 20.9591 15.3229 20.9409 15.2942 20.9202C16.089 22.1625 16.1225 23.3349 16.539 24C15.4043 23.4643 14.4707 22.7914 13.8507 21.9089C13.7574 22.0486 13.7215 22.2272 13.8172 22.4808C13.032 21.7872 12.4312 20.6899 11.9524 19.3208C11.9476 19.3312 11.9452 19.3415 11.9405 19.3493C11.4641 20.7054 10.8656 21.7924 10.0828 22.4808C10.181 22.2272 10.1451 22.0486 10.0493 21.9089C9.42932 22.7914 8.49572 23.4643 7.36104 24C7.77757 23.3375 7.81109 22.1625 8.60584 20.9202C8.56514 20.9487 8.52445 20.9798 8.48615 21.0031C7.17911 21.9141 5.78829 22.2609 4.31848 22.1185C4.56983 22.0228 4.73979 21.8649 4.79964 21.632C2.34117 21.7614 1.12031 20.8711 0 19.898C0.0406952 19.9006 0.0837842 19.9057 0.126873 19.9083C1.57993 19.9808 3.97616 18.5651 6.62853 17.9052C6.61656 17.9 6.6022 17.8948 6.59262 17.8896C3.61709 16.6784 1.9031 14.7451 1.01977 12.3408C1.17537 12.5246 1.35012 12.6178 1.54402 12.6204C0.608034 9.7735 0.677455 7.77035 1.37885 6.29774C1.49375 8.05762 6.66204 9.6855 8.90028 13.3968C8.89071 13.3528 8.88113 13.314 8.87395 13.27C8.32576 10.8087 8.47418 8.07315 9.16121 5.13053C9.20908 5.79307 9.31202 6.22269 9.69982 6.49185C9.91048 3.89085 10.643 1.79971 11.95 0.267578C13.2571 1.79971 13.9896 3.89085 14.2002 6.49185C14.588 6.22269 14.691 5.79307 14.7388 5.13053C15.4378 8.12491 15.5791 10.9045 14.9974 13.3968C15.0309 13.3372 15.0668 13.2829 15.1027 13.2234C15.1051 13.2208 15.1051 13.2182 15.1075 13.213C17.2691 9.84079 21.8318 8.22067 22.4494 6.59796V6.59537C22.4901 6.49702 22.5116 6.39609 22.5188 6.29515C23.2202 7.76776 23.2896 9.77091 22.3536 12.6178C22.5475 12.6126 22.7247 12.5194 22.8779 12.3383C21.9898 14.7529 20.2662 16.6914 17.2691 17.9026C17.3074 17.9129 17.3457 17.9233 17.3816 17.931C20.0651 18.6246 22.4781 20.0584 23.8977 19.8954C22.7797 20.8685 21.5589 21.7588 19.098 21.6294C19.1627 21.8675 19.3302 22.0228 19.584 22.1185Z"
                      fill="#258F67"
                    />
                    <path
                      d="M12.3627 16.6732C12.3627 16.6732 9.45119 17.3788 6.85934 17.5985C3.80271 16.3889 2.04202 14.4581 1.13462 12.057C1.29446 12.2405 1.47398 12.3335 1.67316 12.3361C0.711665 9.49296 0.782978 7.49241 1.50348 6.02173C1.50594 6.02173 1.79857 15.6032 12.3627 16.6732Z"
                      fill="#214842"
                    />
                    <path
                      d="M11.7116 16.7864C11.7116 16.7864 10.0667 16.3102 8.77415 13.0731C8.25027 10.5985 8.39211 7.84804 9.04868 4.88941C9.09443 5.55556 9.1928 5.98751 9.56341 6.25813C9.76473 3.64299 10.4648 1.54046 11.7138 0C11.2174 6.38824 10.904 12.4824 11.7116 16.7864Z"
                      fill="#214842"
                    />
                    <path
                      d="M22.3487 6.552C20.8856 12.8009 17.0985 15.79 12.0293 16.9711C13.0596 16.6693 14.1769 15.0226 15.1296 13.2119C15.132 13.2093 15.132 13.2067 15.1343 13.2015C17.2608 9.81172 21.7419 8.18576 22.3487 6.552Z"
                      fill="#214842"
                    />
                    <path
                      d="M23.9996 19.4003C19.2292 19.9109 15.026 19.3955 12.0508 16.6816C12.0508 16.6816 14.9231 17.4656 17.4842 17.5807C20.1675 18.2208 22.5778 19.5513 23.9996 19.4003Z"
                      fill="#214842"
                    />
                    <path
                      d="M16.4192 23.6094C14.6332 21.5095 13.2143 19.1771 12.0742 16.6633C13.1894 18.0582 14.3113 19.4709 15.3222 20.6281C15.295 20.6077 15.2678 20.5898 15.2406 20.5694C15.9931 21.7982 16.0249 22.9554 16.4192 23.6094Z"
                      fill="#214842"
                    />
                    <path
                      d="M12.2037 19.1457C11.7042 20.4843 11.0767 21.5573 10.256 22.2368C10.3589 21.9864 10.3213 21.8102 10.2209 21.6722C9.57084 22.5433 8.59201 23.2076 7.40234 23.7364C9.34998 21.5445 10.9713 19.2351 12.2137 16.7903C12.3342 17.2476 12.299 18.1545 12.2037 19.1457Z"
                      fill="#214842"
                    />
                    <path
                      d="M12.0016 16.896C11.9154 17.0026 10.0093 19.3149 8.54143 20.9535C7.23401 21.8691 5.84277 22.2176 4.37251 22.0746C4.62394 21.9783 4.79395 21.8197 4.85382 21.5856C2.39461 21.7156 1.17339 20.8209 0.0527344 19.8429C0.0934418 19.8455 0.136544 19.8507 0.179646 19.8533C4.51858 20.2227 8.54862 19.5204 12.0016 16.896Z"
                      fill="#214842"
                    />
                    <path
                      d="M12.811 16.7992C12.811 17.2789 12.4464 17.6674 11.9963 17.6674C11.5462 17.6674 11.1816 17.2789 11.1816 16.7992C11.1816 16.3195 11.5462 15.9309 11.9963 15.9309C12.4464 15.9309 12.811 16.3195 12.811 16.7992Z"
                      fill="#214842"
                    />
                  </svg>{" "}
                </span>
                Weight
              </h4>
              <ul className="list d-flex flex-wrap">
                <li className="list-item">
                  <input
                    onChange={handleweightchange}
                    checked={filterweight === "1"}
                    value={"1"}
                    type="radio"
                    id="weight1"
                    name="weight"
                  />
                  <label htmlFor="weight1">1g</label>
                </li>
                <li className="list-item">
                  <input
                    onChange={handleweightchange}
                    checked={filterweight === "3.5"}
                    value={"3.5"}
                    type="radio"
                    id="weight2"
                    name="weight"
                  />
                  <label htmlFor="weight2">3.5g</label>
                </li>
                <li className="list-item">
                  <input
                    onChange={handleweightchange}
                    checked={filterweight === "5"}
                    value={"5"}
                    type="radio"
                    id="weight3"
                    name="weight"
                  />
                  <label htmlFor="weight3">5g</label>
                </li>
                <li className="list-item">
                  <input
                    onChange={handleweightchange}
                    checked={filterweight === "7"}
                    value={"7"}
                    type="radio"
                    id="weight4"
                    name="weight"
                  />
                  <label htmlFor="weight4">7g</label>
                </li>
                <li className="list-item">
                  <input
                    type="radio"
                    id="weight5"
                    name="weight"
                    onChange={handleweightchange}
                    value={"10"}
                    checked={filterweight === "10"}
                  />{" "}
                  <label htmlFor="weight5">10g</label>
                </li>
                <li className="list-item">
                  <input
                    type="radio"
                    checked={filterweight === "14"}
                    onChange={handleweightchange}
                    value={"14"}
                    id="weight6"
                    name="weight"
                  />{" "}
                  <label htmlFor="weight6">14g</label>
                </li>
                <li className="list-item">
                  <input
                    onChange={handleweightchange}
                    checked={filterweight === "28"}
                    value={"28"}
                    type="radio"
                    id="weight7"
                    name="weight"
                  />{" "}
                  <label htmlFor="weight7">28g</label>
                </li>
              </ul>
            </div>
            <div className="shop_aside-block shop_aside-block--price">
              <h4 className="shop_aside-block_header d-flex align-items-center">
                <span className="leaf">
                  <svg
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M19.584 22.1185C18.1022 22.2634 16.697 21.9115 15.3804 20.9798C15.3517 20.9591 15.3229 20.9409 15.2942 20.9202C16.089 22.1625 16.1225 23.3349 16.539 24C15.4043 23.4643 14.4707 22.7914 13.8507 21.9089C13.7574 22.0486 13.7215 22.2272 13.8172 22.4808C13.032 21.7872 12.4312 20.6899 11.9524 19.3208C11.9476 19.3312 11.9452 19.3415 11.9405 19.3493C11.4641 20.7054 10.8656 21.7924 10.0828 22.4808C10.181 22.2272 10.1451 22.0486 10.0493 21.9089C9.42932 22.7914 8.49572 23.4643 7.36104 24C7.77757 23.3375 7.81109 22.1625 8.60584 20.9202C8.56514 20.9487 8.52445 20.9798 8.48615 21.0031C7.17911 21.9141 5.78829 22.2609 4.31848 22.1185C4.56983 22.0228 4.73979 21.8649 4.79964 21.632C2.34117 21.7614 1.12031 20.8711 0 19.898C0.0406952 19.9006 0.0837842 19.9057 0.126873 19.9083C1.57993 19.9808 3.97616 18.5651 6.62853 17.9052C6.61656 17.9 6.6022 17.8948 6.59262 17.8896C3.61709 16.6784 1.9031 14.7451 1.01977 12.3408C1.17537 12.5246 1.35012 12.6178 1.54402 12.6204C0.608034 9.7735 0.677455 7.77035 1.37885 6.29774C1.49375 8.05762 6.66204 9.6855 8.90028 13.3968C8.89071 13.3528 8.88113 13.314 8.87395 13.27C8.32576 10.8087 8.47418 8.07315 9.16121 5.13053C9.20908 5.79307 9.31202 6.22269 9.69982 6.49185C9.91048 3.89085 10.643 1.79971 11.95 0.267578C13.2571 1.79971 13.9896 3.89085 14.2002 6.49185C14.588 6.22269 14.691 5.79307 14.7388 5.13053C15.4378 8.12491 15.5791 10.9045 14.9974 13.3968C15.0309 13.3372 15.0668 13.2829 15.1027 13.2234C15.1051 13.2208 15.1051 13.2182 15.1075 13.213C17.2691 9.84079 21.8318 8.22067 22.4494 6.59796V6.59537C22.4901 6.49702 22.5116 6.39609 22.5188 6.29515C23.2202 7.76776 23.2896 9.77091 22.3536 12.6178C22.5475 12.6126 22.7247 12.5194 22.8779 12.3383C21.9898 14.7529 20.2662 16.6914 17.2691 17.9026C17.3074 17.9129 17.3457 17.9233 17.3816 17.931C20.0651 18.6246 22.4781 20.0584 23.8977 19.8954C22.7797 20.8685 21.5589 21.7588 19.098 21.6294C19.1627 21.8675 19.3302 22.0228 19.584 22.1185Z"
                      fill="#258F67"
                    />
                    <path
                      d="M12.3627 16.6732C12.3627 16.6732 9.45119 17.3788 6.85934 17.5985C3.80271 16.3889 2.04202 14.4581 1.13462 12.057C1.29446 12.2405 1.47398 12.3335 1.67316 12.3361C0.711665 9.49296 0.782978 7.49241 1.50348 6.02173C1.50594 6.02173 1.79857 15.6032 12.3627 16.6732Z"
                      fill="#214842"
                    />
                    <path
                      d="M11.7116 16.7864C11.7116 16.7864 10.0667 16.3102 8.77415 13.0731C8.25027 10.5985 8.39211 7.84804 9.04868 4.88941C9.09443 5.55556 9.1928 5.98751 9.56341 6.25813C9.76473 3.64299 10.4648 1.54046 11.7138 0C11.2174 6.38824 10.904 12.4824 11.7116 16.7864Z"
                      fill="#214842"
                    />
                    <path
                      d="M22.3487 6.552C20.8856 12.8009 17.0985 15.79 12.0293 16.9711C13.0596 16.6693 14.1769 15.0226 15.1296 13.2119C15.132 13.2093 15.132 13.2067 15.1343 13.2015C17.2608 9.81172 21.7419 8.18576 22.3487 6.552Z"
                      fill="#214842"
                    />
                    <path
                      d="M23.9996 19.4003C19.2292 19.9109 15.026 19.3955 12.0508 16.6816C12.0508 16.6816 14.9231 17.4656 17.4842 17.5807C20.1675 18.2208 22.5778 19.5513 23.9996 19.4003Z"
                      fill="#214842"
                    />
                    <path
                      d="M16.4192 23.6094C14.6332 21.5095 13.2143 19.1771 12.0742 16.6633C13.1894 18.0582 14.3113 19.4709 15.3222 20.6281C15.295 20.6077 15.2678 20.5898 15.2406 20.5694C15.9931 21.7982 16.0249 22.9554 16.4192 23.6094Z"
                      fill="#214842"
                    />
                    <path
                      d="M12.2037 19.1457C11.7042 20.4843 11.0767 21.5573 10.256 22.2368C10.3589 21.9864 10.3213 21.8102 10.2209 21.6722C9.57084 22.5433 8.59201 23.2076 7.40234 23.7364C9.34998 21.5445 10.9713 19.2351 12.2137 16.7903C12.3342 17.2476 12.299 18.1545 12.2037 19.1457Z"
                      fill="#214842"
                    />
                    <path
                      d="M12.0016 16.896C11.9154 17.0026 10.0093 19.3149 8.54143 20.9535C7.23401 21.8691 5.84277 22.2176 4.37251 22.0746C4.62394 21.9783 4.79395 21.8197 4.85382 21.5856C2.39461 21.7156 1.17339 20.8209 0.0527344 19.8429C0.0934418 19.8455 0.136544 19.8507 0.179646 19.8533C4.51858 20.2227 8.54862 19.5204 12.0016 16.896Z"
                      fill="#214842"
                    />
                    <path
                      d="M12.811 16.7992C12.811 17.2789 12.4464 17.6674 11.9963 17.6674C11.5462 17.6674 11.1816 17.2789 11.1816 16.7992C11.1816 16.3195 11.5462 15.9309 11.9963 15.9309C12.4464 15.9309 12.811 16.3195 12.811 16.7992Z"
                      fill="#214842"
                    />
                  </svg>{" "}
                </span>
                Filter by Price
              </h4>
              <div className=" ">
                <input
                  className="contacts_form-form_field field required "
                  type="text"
                  style={{border:'1px solid black'}}
                  value={peicefilter}
                  onChange={(e) => setpricefilter(e.target.value)}
                  placeholder="amount"
                />{" "}
              </div>
            </div>
           
          </div>
        </div>
      </div>
    </div>
  );
};

export default Section1;
